import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { CgChevronDoubleLeft } from 'react-icons/cg';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/staff/reset-password`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email }),
        });
        const data = await response.json();
        if (response.ok) {
          setMessage(data.message);
          setError('');
        } else {
          setError(data.message || 'Something went wrong');
          setMessage('');
        }
      } catch (err) {
        setError('An error occurred while requesting a password reset.');
      }
    };
  
    return (
      <div className="flex justify-center items-center min-h-screen"
      style={{
        background: 'linear-gradient(180deg, #87D601 0%, #002F7F 74%, #002D7E 100%)',
      }}
      >
        <div           className="bg-white p-6 rounded shadow-md w-96"
        >
        <form
          onSubmit={handleSubmit}
        >
            <div className='flex gap-4'>
            <button onClick={() => navigate('/')} className='pb-4 text-primary'>
            <CgChevronDoubleLeft size={24}/>
            </button>
            <h2 className="text-2xl font-bold mb-4 text-primary">Reset Password</h2>
            </div>
          <div className="mb-4">
            <label className="block text-primary mb-2">Email</label>
            <input
              type="email"
              className="w-full p-2 border rounded focus:outline-none focus:ring"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-primary text-white p-2 rounded hover:bg-blue-600"
          >
            Request Reset
          </button>
          {message && <p className="text-green-500 mt-4">{message}</p>}
          {error && <p className="text-red-500 mt-4">{error}</p>}
        </form>
        {/* <Link to={'/confirm-password'}>
              <button type='button' className='text-primary m-4 text-center content-center'>Confirm Password</button>
              </Link> */}
        </div>
      </div>
    );
  };
  

export default ForgotPassword